var $ = global.jQuery = global.$;
var mapConfig = require('config').maps;

var LocMap = require('./LocMap');

/**
 * Locations small map (on home page)
 * @class
 * @extends LocMap
 */
var LocMapMini = LocMap.extend(
  /** @lends LocMapMini.prototype */
  {
  /**
   * Runs when then map is loaded using the google map loader in the _Map base.
   * @param {object} google The google instance that is passed through by the google map loader in the _Map init() method
   */
  onMapLoaded: function(google) {

    // Call the LocMap onMapLoaded() method
    this._super(google);

    // Move the map zoom control to the to right position so as not to conflict with the filters
    this.map.setOptions({
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP
      }
    });

    this.defaultIcon = {
      url: '/assets/images/map-pin-pts.svg',
      scaledSize: new google.maps.Size(32, 50)
    };

    this.cluster.setStyles([{
      anchorIcon: [50, 0],
      anchorText: [-8, 0],
      fontFamily: 'Arial',
      fontWeight: 'bold',
      textColor: '#fff',
      height: 50,
      textSize: 15,
      url: '/assets/images/map-pin-pts.svg',
      width: 32
    }]);


  }
});

module.exports = LocMapMini;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/LocMapMini_PTS.js
// module id = 340
// module chunks = 1